module.exports = __webpack_public_path__ + "img/enstsc_1.7780291c.png";